export default __webpack_public_path__ + "static/media/clear-sky-day.cdc2a03b.svg";